import { useEffect } from "react";
import PropTypes from "prop-types";
import { alignItems } from "../../../../../../../../consts";
import { useLoadImage } from "../../../../../../../../hooks";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../../../../../../../components";
import { Title } from "../../styled";
import { ImageWrapper, LinkText } from "./styled";

export const ListWithIconSection = ({ title, description, linkText, icon }) => {
  const { imageSrc, loadImage } = useLoadImage(icon);

  useEffect(() => {
    loadImage();
  }, [loadImage]);

  return (
    <WrapperContainer
      Container={FlexContainers.FlexRowStart}
      alignItems={alignItems.start}
      gap={24}>
      <ImageWrapper Container={FlexContainers.FlexColumnStart}>
        <img src={imageSrc} alt="icon" />
      </ImageWrapper>

      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        gap={4}>
        <Title>{title}</Title>

        {description && <Paragraph2>{description}</Paragraph2>}
        {linkText && <LinkText>{linkText} →</LinkText>}
      </WrapperContainer>
    </WrapperContainer>
  );
};

ListWithIconSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  linkText: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.node]).isRequired
};
